import React, { ReactElement } from 'react';
import { Button, LoaderButton } from 'idsk-react-components';
import './mpkStartButtons.scss';
import { BackButton, ConfirmModal } from 'slovlex-idsk-react-components';

interface Props {
  onClick: () => void;
  loading: boolean;
  startDateIsToday: boolean,
  config?: boolean,
}

const MpkStartButtons = ({
  onClick,
  loading,
  startDateIsToday,
  config = false,
}: Props): ReactElement => {
  const getSubmitButtonLabel = (): string => {
    if (config) {
      return 'Zmeniť konfiguráciu Pripomienkového konania';
    }
    if (startDateIsToday) {
      return 'Prejsť do štádia Pripomienkové konanie';
    }
    return 'Nakonfigurovať spustenie štádia Pripomienkové konanie';
  };

  const getQuestion = (): string => {
    if (config) {
      return 'Naozaj si prajete uložiť novú konfiguráciu PK?';
    }
    if (startDateIsToday) {
      return 'Naozaj si prajete spustiť štádium "Pripomienkové konanie"?';
    }
    return 'Naozaj si prajete nastaviť spustenie štádia "Pripomienkové konanie" na neskorší dátum?';
  };

  const getDescription = (): string => {
    if (config) {
      return '';
    }
    if (startDateIsToday) {
      return 'Po vykonaní tohto pracovného kroku sa ukončí aktuálne štádium materiálu a spustí sa štádium '
        + '"Pripomienkové konanie". ';
    }
    return 'Keďže je dátum začiatku nastavený na neskorší dátum, '
      + 'po vykonaní tohto pracovného kroku zostane materiál v aktuálnom štádiu až do nastaveného '
      + 'dátumu, pričom bude možné vykonať iba jeden pracovný krok - "Zrušiť nastavené '
      + 'štádium Pripomienkové konanie". Keď nastane určený dátum začiatku, materiál '
      + 'prejde do štádia "Pripomienkové konanie". ';
  };

  return (
    <div className="odoslat-do-mpk-buttons__container">
      <ConfirmModal
        question={getQuestion()}
        description={getDescription()}
        cancelButtonText="Nie"
        confirmButton={
          (
            <Button
              buttonStyle="action"
              size="large"
            >
              Áno
            </Button>
          )
        }
        openButton={(
          <LoaderButton
            size="large"
            disableOutsideClickWhileLoading
            className="odoslat-do-mpk-buttons__submit-button"
            loading={loading}
          >
            {getSubmitButtonLabel()}
          </LoaderButton>
        )}
        doAfterConfirm={onClick}
      />
      <BackButton disabled={loading} />
    </div>
  );
};
export default MpkStartButtons;
